import { Popup } from "components/UI/Popup";
import { CopyTextControl } from "components/controls";

import "./EmbedDialog.scss";

export const EmbedDialog = (props: {
  fixedEmbedCode: string;
  responsiveEmbedCode: string;
  onClose: () => void;
  isOpen: boolean;
}): JSX.Element => {
  const { fixedEmbedCode, responsiveEmbedCode, onClose, isOpen } = props;

  return (
    <Popup
      onClose={onClose}
      isOpen={isOpen}
      popupClass="EmbedDialog"
      title="Embed"
    >
      <>
        <div className="group">
          <label>Fixed frame:</label>
          <CopyTextControl value={fixedEmbedCode}/>
        </div>

        <div className="group">
          <label>Responsive frame:</label>
          <CopyTextControl value={responsiveEmbedCode}/>
        </div>
      </>
    </Popup>
  );
};
